import * as React from 'react'

import { cn } from 'lib/utils'
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle
} from 'components/ui/navigation-menu'

import { useAuth } from 'store/client/authStore'

import { Link, Navigate } from 'react-router-dom';

export function Sidebar() {
  const { user } = useAuth();

  // Kullanıcı bilgisi yoksa (örneğin, kullanıcı çıkış yapmışsa), anasayfaya yönlendir
  if (!user) {
    return <Navigate to="/girisyap" replace />;
  }



  return (
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuLink className={navigationMenuTriggerStyle()} asChild>
            <Link to="/anasayfa">Ana Sayfa</Link>
          </NavigationMenuLink>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuTrigger>Siparişler</NavigationMenuTrigger>
          <NavigationMenuContent>
            <ul className="grid gap-3 p-4 md:w-[400px] lg:w-[500px] lg:grid-cols-[.75fr_1fr]">
              <ListItem href="/siparisler/listele" title="Siparişler">
                Tüm siparişleri listeler
              </ListItem>
              <ListItem
                href="/siparisler/ekle"
                title="Sipariş Ekle"
                onClick={() => localStorage.removeItem('values')}
              >
                Yeni sipariş oluşturmanızı sağlar
              </ListItem>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuLink className={navigationMenuTriggerStyle()} asChild>
            <Link to="/raporlar">Raporlar</Link>
          </NavigationMenuLink>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuLink className={navigationMenuTriggerStyle()} asChild>
            <Link to="/markalar">Markalar</Link>
          </NavigationMenuLink>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuLink className={navigationMenuTriggerStyle()} asChild>
            <Link to="/firmalar">Firmalar</Link>
          </NavigationMenuLink>
        </NavigationMenuItem>
        {user && user.tierType === 'ADMIN' && (
          <NavigationMenuItem>
            <NavigationMenuLink className={navigationMenuTriggerStyle()} asChild>
              <Link to="/kullanıcılar">Kullanıcılar</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
        )}
        {user && user.tierType === 'ADMIN' && (
          <NavigationMenuItem>
            <NavigationMenuLink className={navigationMenuTriggerStyle()} asChild>
              <Link to="/güncellemeler">Güncellemeler</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
        )}
      </NavigationMenuList>
    </NavigationMenu>
  )
}

const ListItem = React.forwardRef(({ className, title, children, ...props }, ref) => {
  return (
    <li>
      <NavigationMenuLink asChild>
        <a
          ref={ref}
          className={cn(
            'block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground',
            className
          )}
          {...props}
        >
          <div className="text-sm font-medium leading-none">{title}</div>
          <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">{children}</p>
        </a>
      </NavigationMenuLink>
    </li>
  )
})
ListItem.displayName = 'ListItem'
